export default "__VITE_ASSET__0bb95d6f__"